import React from "react";
import { Box, Typography } from "@mui/material";
import CollapsibleTable from "../../components/CommonComponents/CollapsibleTable";
import { InvoiceSectionData } from "./datafunctions";
import StyledInvoice from "./StyledInvoice";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { fetchDownloadInvoices } from "../../store/reducers/invoices";
import { useDispatch } from "react-redux";
import NoDataFound from "../PrivateDashboard/NoDataFound";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { toTwoDecimalPlaces } from "../../utils/commonFunctions";
import rollbar from "../../rollbarConfig";
import wanderobelogo from "../../assets/images/wanderobe-logo-1.svg";

const InvoicePage = ({
  data,
  paginationData,
  setPageSize,
  count,
  pageSize,
  setCount,
  loading,
  sxHeight,
}) => {
  const dispatch = useDispatch();
  const heading = [
    "Order no.",
    "Order Completed On",
    "Total Items",
    "Total Amount",
    "Action",
  ];

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);

    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  };

  const downloadInvoice = async (id) => {
    try {
      const res = await dispatch(fetchDownloadInvoices(id));
      const blob = new Blob([res.payload], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `invoice_${id}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (err) {
      console.error("Download error:", err);
      rollbar.error("Error message", err);
    }
  };
console.log("dd :", data)
  const invoiceRows = data?.map((item) =>
    InvoiceSectionData(
      `#${item?.order_number || "--"}`,
      formatDate(item?.completion_date),
      item?.total_items,
      `$${item?.item_total}`,
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "5px",
          cursor: "pointer",
        }}
        role='button'
        tabIndex={0}
        onClick={() => downloadInvoice(item?.id)}
      >
        <FileDownloadOutlinedIcon sx={{ fontSize: "16px", color: "#A78D78" }} />
        <Typography
          sx={{
            fontFamily: "Lexend",
            fontWeight: "400",
            fontSize: { xs: "12px", md: "14px" },
            color: "#A78D78",
          }}
        >
          Download
        </Typography>
      </Box>,
      item?.itemized_breakdown?.map((itemdetails) => ({
        productName: (
          <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <Box
              component='img'
              src={itemdetails?.product_image?.[0] || wanderobelogo}
              sx={{
                height: 40,
                width: 40,
                objectFit: "contain",
                border: "0.62px solid #CBCBCB",
              }}
            />
            <Box display="flex" gap="4px" flexDirection="column">
              <Typography className="text-truncate" fontSize={{ xs: "12px", md: "14px" }}>{itemdetails?.item_name || "--"}</Typography>
              <Box sx={{ display: { xs: "flex", sm: "none" }, alignItems: "center", fontSize: "12px", color: "#656565" }}>{itemdetails?.size || "--"} / <Box sx={{ height: "14px", width: "14px", background: itemdetails?.color_code, marginLeft: "4px", marginRight: "3px", border: "0.1px solid lightgrey" }} />{itemdetails?.color || "--"}</Box>
            </Box>

          </Box>
        ),
        size_color: (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {`${itemdetails?.size || "--"} / `}
            <Box
              sx={{
                height: "14px",
                width: "14px",
                background: itemdetails?.color_code,
                margin: "0 4px",
                border: "0.1px solid lightgrey",
              }}
            />
            {itemdetails?.color || "--"}
          </Box>
        ),
        price: `$${toTwoDecimalPlaces(itemdetails?.price) || "--"}`,
        quantity: `x${itemdetails?.quantity}` || "--",
        totalAmount: `$${itemdetails?.total || "--"}`,
      }))
    )
  );

  const detailsHeading = [
    "Product name",
    "Size/Color",
    "Price",
    "Qty.",
    "total amount",
  ];
  return (
    <StyledInvoice>
      <Box sx={{ display: { xs: "block" } }}>
        <CollapsibleTable
          loading={loading}
          noDataComponent={
            <NoDataFound
              icon={<DescriptionOutlinedIcon className='icon-no-data' />}
              heading='No Invoices Found!'
              subHeading=' No invoices available yet. Invoices will appear here once transactions are processed'
            />
          }
          sxMobileHeight={paginationData?.total_pages <= 3 ? "calc(100vh - 220px)" : "calc(100vh - 257px)"}
          sxHeight={sxHeight}
          detailsHeading={detailsHeading}
          headings={heading}
          rows={invoiceRows}
          isDownIconVisible={true}
          totalCount={paginationData?.total_count}
          totalPages={paginationData?.total_pages}
          pageNo={count}
          pageSize={
            paginationData?.total_count >= 10
              ? pageSize
              : paginationData?.total_count
          }
          setPageNo={setCount}
          setPageSize={setPageSize}
        />
      </Box>
    </StyledInvoice>
  );
};

export default InvoicePage;
